import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';

const steps = [
  { num: '01', icon: 'ri-calendar-check-line', title: 'Book Your Appointment', desc: 'Call (904) 555-0191 or submit our online form. We confirm your booking within 1 hour and provide an upfront quote. No hidden fees.', detail: 'Same-week appointments available Monday through Saturday throughout Jacksonville.' },
  { num: '02', icon: 'ri-truck-line', title: 'Technician Arrives On Time', desc: 'Our certified technician arrives in a branded BBM Services vehicle. We text you when we\'re 30 minutes away. You\'ll always know exactly who\'s coming.', detail: 'All BBM Services technicians carry ID, wear uniforms, and drive marked vehicles.' },
  { num: '03', icon: 'ri-search-eye-line', title: 'Full Inspection Performed', desc: 'Before any cleaning begins, we inspect your chimney, duct system, or dryer vent thoroughly. We document everything with photos and explain what we find.', detail: 'You\'ll see exactly what we see. No pressure. Just honest information.' },
  { num: '04', icon: 'ri-tools-line', title: 'Professional Cleaning Completed', desc: 'Using professional-grade equipment, we clean your system completely. We contain mess, use drop cloths, and leave your home cleaner than we found it.', detail: 'Our high-powered vacuum equipment captures all debris — nothing is left behind.' },
  { num: '05', icon: 'ri-file-list-3-line', title: 'Written Report & Walk-Through', desc: 'After the job, we show you before and after photos, deliver a written service report, and share honest maintenance recommendations going forward.', detail: 'No surprise upsells. If we find a concern, we explain it clearly and give you options.' },
];

export default function ProcessPage() {
  return (
    <>
      <Header />
      <FloatingCTA />

      <section className="pt-32 pb-16 bg-brand-dark relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
            <div className="h-px w-8 bg-brand-amber" />
            Our Process
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-5">How BBM Services Works</h1>
          <p className="text-white/70 text-xl max-w-2xl mx-auto">Simple. Transparent. Professional. Here's exactly what to expect when you book with BBM Services in Jacksonville.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-10">
            {steps.map((step, i) => (
              <div key={step.num} className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="flex-shrink-0 flex flex-col items-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-brand-amber rounded-2xl text-white">
                    <i className={`${step.icon} text-3xl`} />
                  </div>
                  <div className="font-serif text-sm font-bold text-brand-warm-gray/40 mt-2">{step.num}</div>
                  {i < steps.length - 1 && <div className="w-px h-10 bg-stone-200 mt-2" />}
                </div>
                <div className={`flex-1 p-8 rounded-2xl border transition-all ${i === 0 ? 'bg-amber-50 border-brand-amber/20' : 'bg-stone-50 border-stone-200 hover:border-brand-amber/30'}`}>
                  <h2 className="font-serif text-2xl font-bold text-brand-dark mb-3">{step.title}</h2>
                  <p className="text-brand-warm-gray leading-relaxed mb-3">{step.desc}</p>
                  <div className="flex items-start gap-2 text-sm text-brand-light bg-white rounded-lg px-4 py-3 border border-stone-100">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-brand-amber" />
                    </div>
                    {step.detail}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-brand-dark rounded-2xl p-10 text-center">
            <h2 className="font-serif text-3xl font-bold text-white mb-4">Ready to Get Started?</h2>
            <p className="text-white/70 text-lg mb-7">Book your service online or call us now. Same-week appointments across Jacksonville.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-3.5 px-10 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Book Service</Link>
              <a href="tel:+19045550191" className="border-2 border-white/20 hover:border-white/50 text-white font-semibold py-3.5 px-8 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Call (904) 555-0191</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
